import {
    Grid,
    TextField
  } from "@mui/material";

const Address = (props) => {
    const { formik } = props;

    return(
        <div>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    name="phone"
                    id="phone"
                    label="Phone Contact"
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="otherPhone"
                    id="otherPhone"
                    label="otherPhone"
                    variant="outlined"
                    size='small'
                    type="text"
                    fullWidth
                    onChange={formik.handleChange}
                    value={formik.values.otherPhone}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="address"
                    id="address"
                    label="Address"
                    variant="outlined"
                    size="small"
                    type="text"
                    fullWidth
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="otherAddress"
                    id="otherAddress"
                    label="Home Address(GPS link)"
                    variant="outlined"
                    size='small'
                    type="text"
                    fullWidth
                    onChange={formik.handleChange}
                    value={formik.values.otherAddress}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            {/* {formik.errors.submit && (
                <Grid item xs={12}>
                <FormHelperText error>
                    {formik.errors.submit}
                </FormHelperText>
                </Grid>
            )} */}
        </Grid>
    </div>
    )
}

export default Address;